export enum MedicationsFormField {
  MEDICATIONS = 'medications',
  MEDICATION_SUMMARY = 'medications/medication-summary',
  MEDICATIONS_INITIALS_AUTHORIZATION = 'medications/initials-authorization'
}
